import React, { Component } from 'react';
import { CRM } from '../../Values.js';

class Footer extends Component {

  render() {
    const year = new Date().getFullYear()
    return (
      <footer className="footer-container">
        <span>{CRM.sNombre} &copy; {year} - {CRM.sDerechos}</span>
      </footer>
    );
  }

}

export default Footer;
